<template>
  <div class="view">
    <!-- <div class="de-bug-view">
      {{ width }}:{{ height }}
    </div> -->
    <router-view/>
  </div>
</template>

<script>

import ApiService from '@/assets/js/apiService'
const api = new ApiService()
import shareds from '@/assets/js/shared';
const shared = new shareds()
import Router from '@/assets/js/Router';
const router = Router.getInstance();
export default {
  name: 'App',
  data(){
    return {
      width:0,
      height:0
    }
  },
  components: {},
  watch:{},
  computed:{},
  methods:{},
  mounted(){

    router.setRouter(this.$router);

    setInterval(async function(){
      var trainingRecord = JSON.parse(localStorage.getItem('trainingRecord')) || [];
      console.log('trainingRecord', trainingRecord);
      if(trainingRecord.length>0){
        var res = await api.setTrainingRecords(trainingRecord[0]);
        console.log(res);
        if(res.code==10000){
          trainingRecord = JSON.parse(localStorage.getItem('trainingRecord')) || [];
          trainingRecord.splice(0, 1);
          localStorage.setItem('trainingRecord',JSON.stringify(trainingRecord));
        }
      }
    }, 60000)

  },
  async created(){

    this.width = window.innerWidth;
    this.height = window.innerHeight;

    const self = this
    //檢查當日遊玩紀錄
    // 取得 localStorage 中的資料
    shared.initLocalStorageData()
    window.addEventListener('load', function () {
      function isPortrait() {
        return window.matchMedia("(orientation: portrait)").matches;
      }

      function showPortraitAlert() {
        alert(self.$t("orientation_portrait"));
      }

      if (isPortrait()) {
        showPortraitAlert();
      }

      window.addEventListener('orientationchange', function () {
        if (!isPortrait()) {
          showPortraitAlert();
        }
      });
    });

    this.mParam = this.$route.query.m; // 獲取URL中的 m 參數的值
    console.log("mParam=>",this.mParam)

  }
}
</script>
<style scoped>
.full-screen{
    width: 100dvw;
    height: 100dvh;
}
.view{
  position: relative;
}
.de-bug-view{
  position: fixed;
  right: 10px;
  bottom: 10px;
  color: #d3d3d3;
}
</style>
